import React from "react";
import SVGMorph from "../SVGMorph";
import { shouldPress1, shouldPress3 } from "./path";
function ShoulderPress() {
  return (
    <svg
      // style={{ width: "clamp(18rem, 14.8571rem + 15.7143vw, 40rem)" }}
      style={{ width: "clamp(250px, 219.4357px + 9.4044vw, 400px)" }}
      viewBox="0 0 358 642"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <SVGMorph
        paths={[shouldPress1, shouldPress3, shouldPress1]}
        duration="0.4"
        delay="0.2"
      />
    </svg>
  );
}

export default ShoulderPress;
